import React from 'react';

interface ProgressBarProps {
    /** 0-100. */
    percent: number;
    className?: string;
    /** Thin bars sit inside list rows; the default suits panels. */
    size?: 'sm' | 'md';
}

export const ProgressBar: React.FC<ProgressBarProps> = ({
    percent,
    className = '',
    size = 'md'
}) => {
    const height = size === 'sm' ? 'h-[3px]' : 'h-1';
    const clamped = Math.max(0, Math.min(100, percent));

    return (
        <div
            className={`${height} bg-gray-200 rounded-full overflow-hidden ${className}`}
            role="progressbar"
            aria-valuenow={clamped}
            aria-valuemin={0}
            aria-valuemax={100}
        >
            <div
                className={`${height} bg-gray-800 rounded-full`}
                style={{ width: `${clamped}%` }}
            />
        </div>
    );
};

export default ProgressBar;
